import React, { createContext, useContext } from 'react';
import HelloHealthTheme from '../clients/HelloHealth/theme';
import HelloHealthLandingConfig from '../clients/HelloHealth/landingConfig';

import ClientBTheme from '../clients/clientB/theme';

const clientConfigs = {
  hellohealth: {
    theme: HelloHealthTheme,
    landing: HelloHealthLandingConfig,
  },
  clientB: {
    theme: ClientBTheme
  },
};

const ClientContext = createContext({
  clientId: 'hellohealth',
  theme: HelloHealthTheme,
  landing: HelloHealthLandingConfig,
});

export const useClient = () => useContext(ClientContext);

export const ClientProvider = ({ clientId, children }) => {
  const config = clientConfigs[clientId] || clientConfigs.hellohealth;

  return (
    <ClientContext.Provider value={{
      clientId,
      theme: config.theme,
      landing: config.landing,
    }}>
      {children}
    </ClientContext.Provider>
  );
};
